import CardItem from './CardItem';
import Pagination from './Pagination';
import { TabItemsProps } from '../types';

const TabItems = ({
	paginatedItems,
	getIconColor,
	currentPage,
	totalPages,
	totalItems,
	PAGE_SIZE,
	onPageChange,
}: TabItemsProps) => {
	return (
		<div className="flex flex-col">
			{/* Card Grid */}
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				{paginatedItems.map((item, index) => (
					<div key={index} className="h-full" style={{ minHeight: '280px' }}>
						<CardItem item={item} getIconColor={getIconColor} />
					</div>
				))}
			</div>

			{/* Pagination - outside the grid */}
			{totalItems > PAGE_SIZE && (
				<div className="w-full my-4 flex justify-center">
					<Pagination
						currentPage={currentPage}
						totalPages={totalPages}
						onPageChange={onPageChange}
					/>
				</div>
			)}
		</div>
	);
};

export default TabItems;
